import React, { type ReactNode } from 'react'
import { CROSS_CLIENT_AI_EVAL_BLOCKED_MESSAGE } from '../../utils/crossClientFunds'
import { useCrossClientFundsQuotas } from '../../utils/crossClientFundsQuotas'
import {
  CROSS_CLIENT_AI_PHASE_ACCESS_LOADING_MESSAGE,
  CROSS_CLIENT_AI_PHASE_ADMIN_BLOCKED_MESSAGE,
  CROSS_CLIENT_AI_PHASE_BLOCKED_TITLE,
  CROSS_CLIENT_AI_PHASE_PERMISSION_BLOCKED_MESSAGE,
  useCrossClientAiPhaseAccess,
} from '../../utils/crossClientAiPhaseAccess'

export interface CcqAiGate {
  isBlocked: boolean
  // The only blocker is a failed permission check, which an action that rechecks access can recover from.
  canRetryAccess: boolean
  tooltipTitle: string | undefined
  tooltipContent: ReactNode | undefined
}

export const useCcqAiGate = (): CcqAiGate => {
  const { canAiEval, quotaLoading } = useCrossClientFundsQuotas()
  const { hasAiPhaseAccess, hasAdminAccess, accountLoading, accountError } = useCrossClientAiPhaseAccess()

  const isBlocked = quotaLoading || accountLoading || !canAiEval || !hasAiPhaseAccess
  const isPermissionBlocked = !quotaLoading && !accountLoading && canAiEval && !accountError && !hasAiPhaseAccess
  const canRetryAccess = accountError && !quotaLoading && canAiEval
  const tooltipTitle =
    quotaLoading || (accountLoading && !accountError)
      ? undefined
      : !canAiEval
        ? CROSS_CLIENT_AI_EVAL_BLOCKED_MESSAGE
        : accountError
          ? CROSS_CLIENT_AI_PHASE_ACCESS_LOADING_MESSAGE
          : undefined
  const tooltipContent = isPermissionBlocked ? (
    <div className='text-start'>
      <div className='fw-bold'>{CROSS_CLIENT_AI_PHASE_BLOCKED_TITLE}</div>
      <div>{hasAdminAccess ? CROSS_CLIENT_AI_PHASE_ADMIN_BLOCKED_MESSAGE : CROSS_CLIENT_AI_PHASE_PERMISSION_BLOCKED_MESSAGE}</div>
    </div>
  ) : undefined

  return { isBlocked, canRetryAccess, tooltipTitle, tooltipContent }
}
